import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type EntityNameJSON = z.infer<typeof EntityNameSchema.EntityNameJSONZ>;
export type EntityNameParams = z.infer<typeof EntityNameSchema.EntityNameZ>;

export default class EntityNameSchema {
  public static readonly EntityNameJSONZ = z.string().min(1, { message: "Entity name cannot be empty" });
  public static readonly EntityNameZ = z.string().min(1, { message: "Entity name cannot be empty" });

  public static validate(values: unknown): EntityNameParams {
    return parseOrThrow(EntityNameSchema.EntityNameZ, values, {
      logError: true,
      schemaName: "EntityNameSchema",
      operation: "validate",
      payloadSample: values,
    });
  }

  public static validateJSON(values: unknown): EntityNameJSON {
    return parseOrThrow(EntityNameSchema.EntityNameJSONZ, values, {
      logError: true,
      schemaName: "EntityNameSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValid(values: unknown): values is EntityNameParams {
    try {
      EntityNameSchema.validate(values);
      return true;
    } catch {
      return false;
    }
  }

  public static isValidJSON(values: unknown): values is EntityNameJSON {
    try {
      EntityNameSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): EntityNameParams {
    const validatedJSON = EntityNameSchema.validateJSON(data);
    return EntityNameSchema.validate(validatedJSON);
  }

  public static serialize(data: EntityNameParams): EntityNameJSON {
    return EntityNameSchema.validate(data);
  }
}
